import React from 'react';

import { DialogoCreateEdit } from '../../Components/modulo-gerencial-dialogos';
import { NumberInput, TextInput } from '../../Components/modulo-gerencial-formularios';
import { api } from '../../services';

const initialValues = {
  nome: '',
  largura: 10,
  altura: 10,
};

const validadores = {
  nome: (value) => {
    if (!value || value.length < 2) return 'Não pode ser menor que 2';
    if (value.length > 80) return 'Não pode ser maior que 80';
    return '';
  },
  largura: (value) => {
    if (Number.isNaN(value) || value < 10 || value > 100) {
      return 'A largura deve estar entre 10 e 100';
    }
    return '';
  },
  altura: (value) => {
    if (Number.isNaN(value) || value < 10 || value > 100) {
      return 'A altura deve estar entre 10 e 100';
    }
    return '';
  },
};

const transformGetDados = (dados) => ({
  nome: dados.nome,
  largura: dados.largura,
  altura: dados.altura,
});

const transformSalvar = (dados) => ({
  nome: dados.nome,
  largura: dados.largura,
  altura: dados.altura,
});

function Form() {
  return (
    <div>
      <TextInput name="nome" fullWidth label="Nome do mapa" autoFocus />
      <NumberInput name="largura" fullWidth label="Largura (nº de células)" />
      <NumberInput name="altura" fullWidth label="Altura (nº de células)" />
    </div>
  );
}

async function getMensagemConfirmacao(id, dados) {
  if (!id) return 'Deseja realmente finalizar?';

  const { data } = await api.get(
    `/mapas_loja/${id}/contar_enderecos_fora_limite`,
    { params: { largura: dados.largura, altura: dados.altura } },
  );

  if (data.quantidade > 0) {
    const plural = data.quantidade > 1;
    return `${data.quantidade} endereço${plural ? 's' : ''} ${
      plural ? 'ficarão' : 'ficará'
    } fora do novo tamanho e ${
      plural ? 'serão removidos' : 'será removido'
    } do mapa (continuam existindo, só perdem a posição). Deseja continuar?`;
  }

  return 'Deseja realmente finalizar?';
}

const Dialogo = ({ onClose, open, id, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    initialValues={initialValues}
    validators={validadores}
    resource="mapas_loja"
    titleCreate="Novo Mapa"
    titleUpdate="Editar Mapa"
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
    getMensagemConfirmacao={(dados) => getMensagemConfirmacao(id, dados)}
  >
    <Form />
  </DialogoCreateEdit>
);

export default Dialogo;
